import { Avatar } from '@mui/material';

export const CustomAvatar = ({ icon: Icon, customStyles, className }) => (
  <Avatar id="icon-avatar" sx={customStyles} className={className}>
    {Icon}
  </Avatar>
);
